import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "mcm", label: "Metodo MCM" },
  { id: "dashboard", label: "Dati Live" },
  { id: "radar", label: "Logica di Certezza" },
  { id: "whitepaper", label: "White Paper" },
  { id: "audit", label: "Copilot AI" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur border-b border-slate-200 shadow-sm" : "bg-white/70 backdrop-blur-sm border-b border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          <a
            href="#top"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            className="flex items-center gap-4 group"
            data-testid="brand-logo"
          >
            {/* Gruppo Vela primary mark */}
            <div className="flex items-center gap-2.5">
              <div className="w-11 h-11 rounded-md bg-[#0b2545] flex items-center justify-center shadow-sm">
                <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2 L4 22 L12 17 L20 22 Z" />
                  <path d="M12 2 L12 17" opacity="0.6" />
                </svg>
              </div>
              <div className="leading-tight">
                <div className="text-[15px] font-display font-semibold tracking-tight text-[#0b2545]">Gruppo Vela</div>
                <div className="text-[10.5px] font-medium uppercase tracking-[0.18em] text-[#2c7da0]">Home Exchange Copilot AI</div>
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => handleAnchor(n.id)}
                className="px-3.5 py-2 text-sm text-slate-700 hover:text-[#0b2545] hover:bg-slate-100/70 rounded-md transition-colors duration-200 font-medium"
                data-testid={`nav-${n.id}`}
              >
                {n.label}
              </button>
            ))}
            <button
              onClick={() => handleAnchor("audit")}
              className="ml-3 px-5 py-2.5 bg-[#0b2545] text-white hover:bg-[#13315c] transition-colors duration-200 rounded-md text-sm font-semibold shadow-sm"
              data-testid="cta-richiedi-audit"
            >
              Parla col Copilot
            </button>
          </nav>

          <button
            className="lg:hidden p-2 rounded-md border border-slate-200 text-slate-700"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-slate-200 py-4 space-y-1" data-testid="mobile-menu">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => handleAnchor(n.id)}
                className="w-full text-left px-3 py-3 text-sm text-slate-700 hover:text-[#0b2545] hover:bg-slate-50 rounded-md font-medium"
                data-testid={`mobile-nav-${n.id}`}
              >
                {n.label}
              </button>
            ))}
            <button
              onClick={() => handleAnchor("audit")}
              className="w-full mt-2 px-4 py-3 bg-[#0b2545] text-white rounded-md text-sm font-semibold"
              data-testid="mobile-cta-audit"
            >
              Parla col Copilot
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
